import { IAddon, createAddon } from '../../addons/registerOperationHandler';
import { registerControlHandler, createControlHandler } from '../../addons/registerControlHandler';
import { IItemCacheDispatch, IItemCacheThunkAction } from '../../store/actions/ItemCacheActions';
import { progressControl } from '../../controls/progressControl';
import { format, getLocalizedCountValue } from '@ms/utilities-strings/lib/index';
import { IItemCache } from '../../models/IItemCacheObserver';
import { getOverallSimpleProgressBreakdown } from '../progress';
import RenameStrings from './RenameStrings.resx';
import { ProgressPhase } from '../../facets/ProgressFacets';
import { renameProgressKeyFacet } from '../renameItem';

const formatters = {
    [ProgressPhase.started]: (count: number) => format(getLocalizedCountValue(
        RenameStrings.renameStartedItemsTitle,
        RenameStrings.renameCompletedItemsTitleIntervals,
        count) || '',
        count),
    [ProgressPhase.completed]: (count: number) => format(getLocalizedCountValue(
        RenameStrings.renameCompletedItemsTitle,
        RenameStrings.renameCompletedItemsTitleIntervals,
        count) || '',
        count),
    [ProgressPhase.failed]: (count: number) => format(getLocalizedCountValue(
        RenameStrings.renameFailedItemsTitle,
        RenameStrings.renameFailedItemsTitleIntervals,
        count) || '',
        count),
    [ProgressPhase.canceled]: (count: number) => format(getLocalizedCountValue(
        RenameStrings.renameFailedItemsTitle,
        RenameStrings.renameFailedItemsTitleIntervals,
        count) || '',
        count),
};

/**
 * Addon to be registered by the RenameAction component which manages the Progress items for renames.
 */
export const renameProgressAddon: IAddon = createAddon(() => {
    return (dispatch: IItemCacheDispatch) => {
        dispatch(registerControlHandler(renameProgressKeyFacet, progressControl)(
            createControlHandler()(getRenameItemsProgressControl)
        ));
    };
});

/**
 * Gets the progress control for rename, which emits the strings representing the state of a rename.
 */
function getRenameItemsProgressControl(): IItemCacheThunkAction<typeof progressControl.type> {
    return (dispatch: IItemCacheDispatch) => {
        return getRenameProgressOverrides;
    };
}

function getRenameProgressOverrides(itemCache: IItemCache, props: typeof progressControl.inputType): typeof progressControl.returnType {
    const {
        phase,
        count
    } = getOverallSimpleProgressBreakdown(itemCache, props);

    const title = formatters[phase](count);

    return {
        ...(title ? {
            title
        } : {})
    };
}
